import * as React from "react";
import { useLocation } from '@reach/router';
import { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import '../styles/layout.css';
import '../styles/styles.css';
import '../styles/scrollToTopButton-styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Footer from "../components/footer";
import '../fonts/hco_fonts/hco_fonts.css'
import NavBarTop from "./navBarTop";
import NavBarMainHome from "./navBarMainHome";
import NavBarMobile from "./navBarMobile";
import Hero from "./hero";
import ToolKit from "./toolkit";
import StudentOpps from "../components/student-opps";

export default function Layout({ children }) {

  const data = useStaticQuery(graphql`
    query {
      allContentfulCrNavGroup {
      nodes {
        megaMenuLayout
        navGroupName
        navDescription
        navGroupAltName
        megaMenuLayout
        navOrder
        navLocation
        navSlug
        navUrl
        navImage{
                  url
                }

        navNextLevel {
          navItemName
          navDescription
          showhideName
          showhideNavDescription
          navImage{
                  url
                }
          navSlug

          navNextLevel {
            navItemName
            navDescription
            showhideName
            showhideNavDescription
            navImage{
                  url
                }
            navSlug

            navNextLevel {
              navItemName
              navDescription
              showhideName
              showhideNavDescription
              navImage{
                  url
                }
              navSlug

              navNextLevel {
                navItemName
                navDescription
                showhideName
                showhideNavDescription
                navImage{
                  url
                }
                navSlug
              }
            }
          }
        }
      }
    }
    allContentfulCrPage {
        nodes {
            id
            contentful_id
            slug
            title
        }}


    # allContentfulCrNavItem {
    #   nodes {
    #     navItemName
    #     navSlug
    #     navDescription
    #     showhideName
    #     showhideNavDescription
    #     navImage{
    #               url
    #             }

    #     navNextLevel {
    #       navItemName
    #       navDescription
    #       showhideName
    #       showhideNavDescription
    #       navImage{
    #               url
    #             }
    #       navSlug

    #       navNextLevel {
    #         navItemName
    #         navDescription
    #         showhideName
    #         showhideNavDescription
    #         navImage{
    #               url
    #             }
    #         navSlug

    #         navNextLevel {
    #           navItemName
    #           navDescription
    #           showhideName
    #           showhideNavDescription
    #           navImage{
    #               url
    #             }
    #           navSlug

    #           navNextLevel {
    #             navItemName
    #             navDescription
    #             showhideName
    #             showhideNavDescription
    #             navImage{
    #               url 
    #             }
    #             navSlug
    #           }
    #         }
    #       }
    #     }
    #   }
    # }
  }
  `);

  const menuItems = data.allContentfulCrNavGroup.nodes;
  //const navItems = data.allContentfulCrNavItem.nodes;

  // const [url, setUrl] = useState(null);
  // const isBrowser = () => typeof window !== "undefined";

//   useEffect(() => {
//     setUrl(window.location.pathname);
//   }, [(isBrowser() && window.location.pathname)]);

//   useEffect(() => {
//     const isBrowser = typeof window !== "undefined";
//     if (isBrowser) {
//       setUrl(window.location.pathname);
//     }
//   }, []);

  const location = useLocation();
   if (location.pathname ===  "/") {
     return (
       <>
       <NavBarMobile menuItems={menuItems} />
       <NavBarTop menuItems={menuItems} interior={false} data={data}/>
       <NavBarMainHome menuItems={menuItems} interior={false} />
       <Hero />
       <StudentOpps />
       <ToolKit />
         <main className="main home container-fluid">
           {children}
         </main> 
         <Footer />
       </>
     )
   }
  
   else if (location.pathname !== "/"){
     return (
       <>
         <NavBarMobile menuItems={menuItems} />
         <NavBarTop menuItems={menuItems} interior={true} data={data}/>
         <NavBarMainHome menuItems={menuItems} interior={true} />
         <main className="main container-fluid">
           {children}
         </main>
         <Footer />
       </>
     );
   }


}